import React from "react";
import classes from "./Image.module.css";
const Image = (props) => {
  const {
    src,
    alt = "product-image",
    label,
    height = "75px",
    width = "75px",
  } = props;

  return (
    <div className={classes["image-container"]}>
      <img
        style={{ height, width }}
        className={classes["image"]}
        src={src}
        alt={alt}
      />
      <p className={classes["image-label"]}>{label}</p>
    </div>
  );
};

export default Image;
